<template>
    <div class="container container-main-page">
        <div class="section ">
            <sidebar-container>
                <template v-slot:sidebar>
<!--                    <category-nav></category-nav>-->
                </template>
                <template v-slot:content>
                    <carousel-main></carousel-main>
                </template>
            </sidebar-container>
        </div>
        <div class="section">
            <best-prod-section></best-prod-section>
        </div>
        <div class="section">
            <categories-section></categories-section>
        </div>
    </div>
</template>

<script>
    import RangeSlider from 'vue-range-slider'
    import 'vue-range-slider/dist/vue-range-slider.css'

    import CarouselMain from '../components/Carousel/CarouselMain';
    import CategoryNav from '../components/Menu/CategoryNav';
    import SidebarContainer from '../components/Containers/SidebarContentContainer';
    import BestProdSection from '../components/Sections/BestProdSection';
    import CategoriesSection from '../components/Sections/CategoriesSection';
    import SidebarMain from '../components/Sidebars/SidebarMain';
    export default {
        name: "MainPage",
        components: {
            RangeSlider,
            CategoriesSection,
            BestProdSection,
            SidebarMain,
            SidebarContainer,
            CategoryNav,
            CarouselMain
        }
    };
</script>

<style scoped>

</style>
